import styled from 'styled-components'
import { Button as AntButton, Typography, Form } from 'antd'
import { SPACING } from '../../../styles/theme'

const { Text: AntText } = Typography

/**
 * Styled components for ResetPasswordForm component
 * Replaces inline styles with reusable styled components
 */

// Secondary text with block display and bottom margin
export const SecondaryText = styled(AntText)`
  display: block;
  margin-bottom: ${SPACING.xl};
`

// Form item with no bottom margin
export const FormItemNoMargin = styled(Form.Item)`
  margin-bottom: 0;
`

// Full width button
export const FullWidthButton = styled(AntButton)`
  width: 100%;
`
